import { useSelector } from "react-redux"
import { useGetUserResourceAccessPropertiesQuery } from "../../services/bClientApi"
import { getSelectedPropertiesFromLocal, saveSelectedPropertiesToLocal } from "../../Pages/AdrOccupancyReporter/adrOccupancyHelpers"
import { accountSelector } from "../../redux/account/accountSlice"
import { useMemo } from "react"
import { hasChildren } from "../../Helpers/Property/hasChildren"
import { PropertyType } from "../../Types/propertyTypes";
import { hasLinkedService } from "../../Helpers/Property/hasLinkedService"

export default function useMyProperties(options: {
  allData?: boolean
  accessRules?: {
    hideCleaning?: boolean,
    hideBookingGuest?: boolean
  },
  filter?: {
    quickFilter?: string
    hideParents?: boolean
  }
} = {}) {

  const {
    allData = false,
    accessRules = {},
    filter = {}
  } = options

  const {
    hideCleaning,
    hideBookingGuest
  } = accessRules

  const {
    _id,
    // username, 
    token,
    initialized,
    // firstName, lastName, email, profilePic, role, loading, error, message 
  } = useSelector(accountSelector)

  const {
    data,
    error,
    isLoading,
    isFetching,
    requestId
  } = useGetUserResourceAccessPropertiesQuery({
    userId: _id ? _id : '',
    pagination: {
      page: 1,
      limit: 150,
      all: true,
    },
    allResourceData: allData
  }, {
    skip: !token || !initialized || !_id,
    refetchOnFocus: false,
    refetchOnMountOrArgChange: 5 * 60 // in seconds
  })

  const myProperties = useMemo(() => {
    const myPropertiesData: {
      [propertyId: string]: PropertyType
    } = {}
    const propertyList: PropertyType[] = []
    if (data?.docs) {
      data.docs.forEach((resourceEntry: {
        accessRules?: {
          hideCleaning?: boolean,
          hideBookingGuest?: boolean
        },
        propertyData: PropertyType[]
      }) => {
        if (accessRules && Object.keys(accessRules).length > 0) {
          if (hideCleaning && resourceEntry?.accessRules?.hideCleaning) {
            return
          }
          if (hideBookingGuest && resourceEntry?.accessRules?.hideBookingGuest) {
            return
          }
        }
        resourceEntry.propertyData.forEach((property) => {
          if (filter.quickFilter && filter.quickFilter.length > 0) {
            if (property.title.toLowerCase().indexOf(filter.quickFilter.toLowerCase()) === -1) {
              return
            }
          }
          if (filter.hideParents) {
            if (hasChildren(property)) {
              return
            }
          }

          propertyList.push(property)
        })
      })
    }
    // sort propertyList by titles
    propertyList.sort((a: PropertyType, b: PropertyType) => {
      return a.title.localeCompare(b.title)
    })
    propertyList.forEach((property: PropertyType) => {
      myPropertiesData[property._id] = property
    })
    return myPropertiesData
  }, [data, hideCleaning, hideBookingGuest, accessRules, filter])


  const selectedProperties = getSelectedPropertiesFromLocal()
  let foundInvalidProperty = false
  Object.keys(selectedProperties).forEach((propertyId: string) => {
    if (!myProperties[propertyId]) {
      foundInvalidProperty = true
    }
  })
  if (foundInvalidProperty) {
    saveSelectedPropertiesToLocal({})
  }

  const nonBlockingFontaineUnitPropertyIds = {} as Record<string, string>

  const publicPropertyIdKeys = Object.keys(myProperties).filter((propertyId) => {
    const propertyData = myProperties[propertyId]

    // check if fontaine unit
    if (
      hasLinkedService(propertyData, 'fontaine', false) &&
      hasLinkedService(propertyData, 'blockingProperty', false) &&
      !hasChildren(propertyData) &&
      propertyData._id
    ) {
      nonBlockingFontaineUnitPropertyIds[propertyData._id] = propertyData._id
    }

    return propertyData.public
  })



  return {
    myProperties,
    publicPropertyIdKeys,
    nonBlockingFontaineUnitPropertyIds,
    isLoading,
    isFetching,
    error,
    requestId
  }
}
